import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as LogoIcon } from "components/Icons/logo.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { Link } from "react-router-dom";
import { links } from "utilities/links";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    root: {
      "& > svg": {
        display: "block",
        width: "32px",
        height: "auto",
      },
    },
    image: {
      height: "auto",
      maxWidth: "100%",
      verticalAlign: "middle",
    },
  }),
);

export function OLIcon(props: { isDrawerOpen: boolean }) {
  const classes = useStyles();

  return (
    <Link className={classes.root} to={links.homepage}>
      <LogoIcon />
    </Link>
  );
}
